import Vue from 'vue';
import outgoingPostMessageUtils from '@/utils/eventCommunicationUtils/outgoingPostMessageUtils';
import mobileUtils from '@/utils/appUtils/mobileUtils';
import incomingPostMessageUtil from '@/utils/eventCommunicationUtils/incomingPostMessageUtil';
import '@/utils/partnerSdk/partnerSdk'; // This exposes window.businessPlatformSDK
import App from './App.vue';
import ds from './plugins/designSystem';
import router from './router';
import store from './store';
import { i18n } from './plugins/i18n';
import AnalyticsPlugin from './plugins/analytics';
import { listenToDesignSystemClicks } from './plugins/designSystemClickTracking';
import '@/plugins/index';
import '@/../styles/variables.scss';
import '@/../styles/safe-area.scss';
import '@/modules/common/directives';

Vue.config.productionTip = false;
window.mobileUtils = mobileUtils;

const app = new Vue({
  router,
  vuetify: ds,
  store,
  i18n,
  AnalyticsPlugin,
  render: (h) => h(App),
}).$mount('#app');

listenToDesignSystemClicks(app);

incomingPostMessageUtil.init();
outgoingPostMessageUtils.post('pov_ready'); // TODO: mobile-app.js.erb
